module.exports = __webpack_public_path__ + "img/bagel.e2c9b9cb.png";